import { createFileRoute, useSearch } from '@tanstack/react-router'
import { useBreadcrumbFromRoute } from '@/hooks/use-breadcrumb-from-route'
import { PaymentsSidebar, type PaymentsSection } from '@/components/settings/payments-sidebar'
import { StripePaymentsSection } from '@/components/settings/payments/stripe-payments-section'
import { DisputesSection } from '@/components/settings/disputes/disputes-section'
import { WebhooksSection } from '@/components/settings/webhooks/webhooks-section'
import { requirePermission, PermissionDeniedRoute } from '@/lib/require-permission-guard'

type PaymentsSearch = {
  section?: PaymentsSection
}

export const Route = createFileRoute('/_app/_settings/payments')({
  component: PaymentsPage,
  validateSearch: (search: Record<string, unknown>): PaymentsSearch => {
    return {
      section: (search.section as PaymentsSection) || 'stripe',
    }
  },
  // Stripe Connect and webhooks are Settings; disputes are Payments — either
  // permission gets you in.
  beforeLoad: async ({ context }) => {
    await requirePermission(
      context.queryClient,
      ['SettingsManage', 'PaymentsView'],
      'payment settings'
    )
  },
  errorComponent: PermissionDeniedRoute,
})

function PaymentsPage() {
  useBreadcrumbFromRoute()
  const search = useSearch({ from: '/_app/_settings/payments' })
  const currentSection = search.section || 'stripe'

  return (
    <div className="flex h-full overflow-hidden">
      <div className="scroll-fade-y flex-shrink-0 overflow-y-auto">
        <PaymentsSidebar />
      </div>
      <div className="flex flex-1 flex-col overflow-y-auto">
        <div className="flex flex-col gap-4 p-6">
          {currentSection === 'stripe' && <StripePaymentsSection />}
          {currentSection === 'disputes' && <DisputesSection />}
          {currentSection === 'webhooks' && <WebhooksSection />}
        </div>
      </div>
    </div>
  )
}
